const config = {
  frapCon: {
    DESTINATION: 'Mallorca, Spanien',
    TRAVEL_DATE: '2026-04-28 09:00:00',
  },
  vacation: {
    DESTINATION: 'Mallorca, Spanien',
    TRAVEL_DATE: '2024-07-02 07:50:00',
  },
  tenerife: {
    DESTINATION: 'Teneriffa, Spanien',
    TRAVEL_DATE: '2026-06-13 09:10:00',
  }
};

export default config;
